export default __webpack_public_path__ + "static/media/curious-cat3.61cd3c20.svg";